import React, {useEffect, useState} from "react";
import Select from "./Select";
import {useTranslation} from "react-i18next";
import PromiseBuilder from "../../utils/PromiseUtils";
import {useNotifications} from "../../hooks/notification/notificationHook";
import ApiClient from "../../api/ApiClient";
import PropTypes from "prop-types"

function MultiSelect(props) {
  const {t} = useTranslation();
  const [stages, setStages] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const {
    addErrorNotification,
  } = useNotifications();

  useEffect(() => {
    if (searchQuery !== "") {
      fetchStages(searchQuery);
    }
  }, [searchQuery]);

  useEffect(() => {
    if(props.selectedValues != null) {
      setStages(props.selectedValues.multiselectItems)
    }
  }, [props.selectedValues])

  function fetchStages(searchQuery) {
    if(searchQuery){
      new PromiseBuilder()
        .then(() => ApiClient.get(props.endpoint, {filter: "code:LIKE:"+searchQuery+" OR name:LIKE:"+searchQuery}))
        .then((res) => {
          setStages(res.data.payload.content);
        })
        .catch((res) => addErrorNotification(t("toast.fetch_failed_code", {code: res.code}), t("toast.error")))
        .run();
    }
    else{
      new PromiseBuilder()
        .then(() => ApiClient.get(props.endpoint))
        .then((res) => {
          setStages(res.data.payload.content);
        })
        .catch((res) => addErrorNotification(t("toast.fetch_failed_code", {code: res.code}), t("toast.error")))
        .run();
    }

  }

  const handleSearchQueryChange = (newSearchQuery) => {
    if (newSearchQuery !== "") {
      setSearchQuery(newSearchQuery);
      fetchStages(newSearchQuery);
    }
  };

  return (
    <Select label={props.label}
            searchLabel={t("start_typing_to_search")}
            options={stages}
            formField={props.formField}
            className="multi-select"
            isMultiSelect={true}
            multiSelectValues={props.selectedValues}
            onSearchQueryChange={handleSearchQueryChange}
            disabled={props.disabled}
    />)
}

MultiSelect.propTypes = {
  formField: PropTypes.object,
  label: PropTypes.string,
  selectedValues: PropTypes.object,
  disabled: PropTypes.bool,
  endpoint: PropTypes.string,
}
export default MultiSelect;
